export default "__VITE_ASSET__CwGTdLs$__"